export default __webpack_public_path__ + "static/media/IconDesc_Battery.256.535147da.png";